import { useFormik } from 'formik';
import { PrimaryStorage } from '../../core/redux/auth/authTypes';
import { getAppConfigsLS } from '../../core/utils/auth/authUtils';
import * as Yup from 'yup';
import { selectDirectory } from '../../core/database/manager/fileManager';
// import { loginUser } from '../../core/redux/auth/actions/actions';
import { v4 as uuid } from 'uuid';
import { saveDirectoryHandler } from '../../core/database/user/multiUserStorage';
import { ResultWithOptionalError } from '../../core/types/generic/results';
import { useEditable, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../core/hooks/storeHooks';
import { loginUser } from '../../core/redux/auth/thunks/user';
import { useEffect } from 'react';

interface FormikState {
  fullname: string;
  email: string;
  password: string;
  primaryStorage: PrimaryStorage;
}

const signInSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    )
    .matches(/ORANGE!29fl2B6Emgs2ho0l4e454@/, 'Incorrect Password'), // TODO remove this validation after actual pass implementation
  email: Yup.string().email('Invalid email').required('Required'),
  fullname: Yup.string().min(3).max(10),
});

export default () => {
  const toast = useToast();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const navigateHome = () => navigate('/');

  useEffect(() => {
    document.title = 'Enigma';
  }, []);

  const storageSelected: boolean = !!getAppConfigsLS()?.primaryStorage;

  const onSubmit = async (state: FormikState) => {
    let directoryHandler: FileSystemDirectoryHandle | undefined = undefined;
    if (
      !storageSelected &&
      state.primaryStorage === PrimaryStorage.FileSystem
    ) {
      const { error, directoryHandler: dirHandler } = await selectDirectory();
      if (error) return;
      if (dirHandler) {
        const result: ResultWithOptionalError<boolean> =
          await saveDirectoryHandler(dirHandler);
        if (result.error)
          return toast({ title: result.error.message, position: 'top' });
        directoryHandler = dirHandler;
      }
    }
    // TODO Remove this dummy user with actual user once connected with api
    const data = {
      userMetaData: {
        id: uuid(),
        email: state.email,
        username: 'johndoe1',
        fullname: state.fullname ?? 'John Doe',
      },
      primaryStorage: state.primaryStorage,
      storageSelected,
      navigateHome,
      directoryHandler,
    };
    dispatch(loginUser(data));
  };

  const formik = useFormik<FormikState>({
    initialValues: {
      fullname: 'John Doe',
      email: 'admin-organization1@aliva.com', //storageSelected ? '' : 'admin-organization1@aliva.com',
      password: 'ORANGE!29fl2B6Emgs2ho0l4e454', // storageSelected ? '' : 'ORANGE!29fl2B6Emgs2ho0l4e454',
      primaryStorage: PrimaryStorage.IndexedDB, // Will be ignored if already set by admin user
    },
    validationSchema: signInSchema,
    onSubmit,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const changePrimaryStorage = (storage: PrimaryStorage) =>
    formik.setValues({
      ...formik.values,
      primaryStorage: storage,
    });

  return {
    storageSelected,
    formik,
    changePrimaryStorage,
  };
};
